import { useTranslation } from 'react-i18next';
import { Paper, Stack, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';
import DietaryAttributeChips from '../../RecipeV2/components/DietaryAttributeChips';

interface AllergensAttributesTabProps {
  item: RangePlanningItem;
}

/** Reuses RecipeV2's DietaryAttributeChips component/types directly, since allergen and
 * dietary-attribute governance is shared conceptually between Recipes and Items. */
const AllergensAttributesTab = ({ item }: AllergensAttributesTabProps) => {
  const { t } = useTranslation('rangePlanningItems');

  if (item.dietaryAttributes.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noAllergensAttributes', 'No allergen or dietary attribute data recorded for this item.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined"
      sx={{ p: 4 }}>
      <Stack spacing={2}>
        <Typography variant="textSM"
          color="text.secondary">
          {t('allergensAttributesIntro', 'Allergen and dietary attribute status for this item, grouped by category.')}
        </Typography>
        <DietaryAttributeChips
          attributes={item.dietaryAttributes}
          groupByCategory
          showName
          size="medium"
        />
      </Stack>
    </Paper>
  );
};

export default AllergensAttributesTab;
